import Layout from "@/components/common/Layout/Layout";
import React, { useState } from "react";
import background from "../../assets/mic.webp";
import logo from "../../assets/logo podcast color .png";
import {
  FaAngleDown,
  FaIoxhost,
  FaMicrophoneAlt,
  FaRecycle,
  FaUserTag,
  FaUsers,
} from "react-icons/fa";
import { FcLike } from "react-icons/fc";
import Image from "next/image";
import {
  useGetAllPodcastQuery,
  useMostLikePodcastQuery,
  useMostViewPodcastQuery,
  useRecommendationPodcastQuery,
  useSearchItemsQuery,
} from "@/Redux/features/podcast/podcastApi";
import Loading from "@/components/common/loading";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import { formatCount } from "@/utilies/CountPositiveComments";

const Podcast = () => {
  const router = useRouter();
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [searchRecommanded, setSearchRecommanded] = useState(false);
  const [searchMostView, setSearchMostView] = useState(false);
  const [searchMostLike, setSearchMostLike] = useState(false);

  //============================  recommendation Podcast =====================================
  const { data: recommendationPodcast } = useRecommendationPodcastQuery();
  const recommendationPodcasts = recommendationPodcast?.recommendations?.slice(
    0,
    10
  );

  //============================  most view Podcast =====================================
  const { data: mostViewPodcast } = useMostViewPodcastQuery();
  const MostViewPodcast = mostViewPodcast?.podcast?.slice(0, 10);

  //============================  most liked Podcast =====================================
  const { data: mostLikedPodcast } = useMostLikePodcastQuery();
  const MostLikedPodcast = mostLikedPodcast?.podcast?.slice(0, 10);

  //============================  all Podcast =====================================
  const { data: podcast, isLoading, refetch } = useGetAllPodcastQuery(limit);

  const { data: searchItem, isFetching } = useSearchItemsQuery(search);

  const handleLoadMore = () => {
    setLimit(limit + 10);
    refetch();
  };

  const AllPodcast =
    searchRecommanded === true
      ? recommendationPodcasts
      : searchMostView === true
      ? MostViewPodcast
      : searchMostLike === true
      ? MostLikedPodcast
      : search
      ? searchItem?.result?.podcasts
      : podcast?.podcast;

  return (
    <Layout pageTitle={"Podcast | Shows"}>
      {isLoading || isFetching && <Loading />}

      <section
        style={{ background: `url(${background.src})` }}
        className="relative h-auto !bg-no-repeat !bg-center !bg-cover z-10"
      >
        <div className="absolute top-0 left-0 w-full h-full bg-[#d4d4ec]  opacity-90  dark:bg-gray-900 -z-10"></div>

        <section className="max-w-screen-xl  mx-auto p-2">
          <p className="text-3xl md:text-4xl lg:text-6xl dark:text-white pt-10 font-bold">
            Shows Podcasts
          </p>

          <div className="text-sm dark:text-white flex justify-between my-10 md:my-14 lg:my-20 font-semibold">
            <p className="uppercase">
              Result 1-{AllPodcast?.length} of{" "}
              {podcast?.pagination?.totalPodcast?.length}
            </p>
          </div>

          <section className="md:grid md:grid-cols-2 lg:grid-cols-4 gap-10 pb-10">
            <div className="lg:col-span-2 py-5">
              <div className="bg-gray-50 dark:bg-gray-700 dark:text-white p-10 rounded-lg">
                <p className="text-2xl font-bold">Search</p>

                <div className="md:flex justify-between items-center">
                  <input
                    className="p-2 rounded-md mt-5 dark:bg-gray-700 border"
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e?.target?.value)}
                  />
                  {search && (
                    <div
                      onClick={() => {
                        setSearch("");
                        setSearchRecommanded(false);
                        setSearchMostView(false);
                        setSearchMostLike(false);
                      }}
                      className="my-2 text-lg cursor-pointer text-green-600 font-semibold flex gap-2"
                    >
                      <FaRecycle className="my-auto" /> Re-fetch all
                    </div>
                  )}
                </div>
              </div>

              <div className="mt-5 dark:text-white">
                <p className="text-2xl font-bold">Suggested Podcast</p>
                <div className="grid grid-cols-2 gap-3 text-center mt-10">
                  <p
                    onClick={() => {
                      setSearchRecommanded(true);
                      setSearchMostLike(false);
                      setSearchMostView(false);
                    }}
                    className="cursor-pointer hover:bg-blue-400 p-1 my-auto border border-black dark:border-white rounded-2xl"
                  >
                    Recomanded Podcast
                  </p>
                  <p
                    onClick={() => {
                      setSearchRecommanded(false);
                      setSearchMostLike(false);
                      setSearchMostView(true);
                    }}
                    className="cursor-pointer hover:bg-blue-400 p-1 my-auto border border-black dark:border-white rounded-2xl"
                  >
                    Most View Podcast
                  </p>
                  <p
                    onClick={() => {
                      setSearchRecommanded(false);
                      setSearchMostLike(true);
                      setSearchMostView(false);
                    }}
                    className="cursor-pointer hover:bg-blue-400 p-1 my-auto border border-black dark:border-white rounded-2xl"
                  >
                    Most Like Podcast
                  </p>
                </div>
              </div>
            </div>

            {AllPodcast?.length > 0 ? (
              <>
                {AllPodcast?.map((podcast, i) => (
                  <div
                    key={i}
                    className="relative lg:col-span-1   bg-gray-100 dark:text-white dark:bg-gray-800 rounded my-2"
                  >
                    <div className="p-2">
                      <Image
                        className="w-full h-72 lg:w-72 md:h-64 mx-auto   rounded"
                        width={600}
                        height={200}
                        src={`${
                          podcast?.picture?.path ? podcast?.picture?.path : "/"
                        } `}
                        alt="logo"
                      />

                      <div className="my-5 md:my-auto ">
                        <p className="text-xl font-bold my-3 ">
                          {podcast?.title}
                        </p>

                        <div className="flex gap-2">
                          <FaMicrophoneAlt className="my-auto" />
                          <p className="my-auto">Episodes: </p>
                          <p>{podcast?.episodes?.length}</p>
                        </div>

                        <div className="flex gap-2">
                          <FaUsers className="my-auto" />
                          <p className="my-auto">Followers: </p>
                          <p>
                            {formatCount(
                              podcast?.totalFollowers
                                ? podcast?.totalFollowers
                                : 0
                            )}
                          </p>
                        </div>

                        <p className="text-base flex gap-2">
                          <FaUserTag className="my-auto" />
                          <span>Author:</span>
                          {podcast?.createdBy?.firstName}{" "}
                          {podcast?.createdBy?.lastName}
                        </p>
                        <p className="text-base flex gap-2">
                          <FaIoxhost className="my-auto" />
                          Host name:
                        </p>
                        <p className="flex flex-col mb-16">
                          {podcast?.hosts &&
                            podcast?.hosts?.map((host, i) => (
                              <span
                                key={i}
                                className="text-base pl-5 font-semibold"
                              >
                                {i + 1}. {host}
                                {podcast?.hosts?.length === i + 1 ? "." : ","}
                              </span>
                            ))}
                        </p>
                      </div>
                    </div>
                    <div className="absolute  bottom-0  w-full ">
                      <button
                        className="w-full  p-2 bg-blue-600 text-white rounded-b mt-3"
                        onClick={() =>
                          router.push(`/view-podcast?id=${podcast?._id}`)
                        }
                      >
                        View Podcast
                      </button>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <>
                <p className="lg:col-span-2 flex items-center justify-center border text-2xl dark:text-white text-center font-semibold">
                  {" "}
                  No Podcast Found
                </p>
              </>
            )}
          </section>

          {AllPodcast?.length > 0 && (
            <div className="flex justify-center lg:py-10 ">
              <button
                onClick={handleLoadMore}
                className=" uppercase text-lg font-bold text-white bg-gradient-to-r  from-blue-400 to-[#5E1CE4] p-4 px-7 rounded-[50px]"
              >
                Load More
              </button>
            </div>
          )}
        </section>
      </section>
    </Layout>
  );
};

export default Podcast;
